import { render, staticRenderFns } from "./ChangeStatusOld.vue?vue&type=template&id=4c0a6860&scoped=true"
import script from "./ChangeStatusOld.vue?vue&type=script&lang=js"
export * from "./ChangeStatusOld.vue?vue&type=script&lang=js"
import style0 from "./ChangeStatusOld.vue?vue&type=style&index=0&id=4c0a6860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a6860",
  null
  
)

export default component.exports